import { Pipe, PipeTransform } from '@angular/core';
import { Order, OrderItem } from '../api/contracts/order';
import { OrderItemStatus } from '../types/order';
import { OrderService } from '../services/order.service';

@Pipe({
  name: 'getOrderStatus',
})
export class GetOrderStatusPipe implements PipeTransform {
  constructor(private readonly orderService: OrderService) {}

  transform(order: Order): OrderItemStatus {
    return this.orderService.getOrderStatus(order);
  }
}
